import React from 'react'
import PropTypes from 'prop-types'

const Badge = ({
  variant = 'primary',
  size = 'md',
  className = '',
  ariaLabel = '',
  chip = false,
  onClick,
  children,
  ...other
}) => {
  let colorClass = `bg-${variant}${(variant === 'gray' && !chip) ? '-700' : ''}`
  if (chip) {
    colorClass += `${variant === 'gray' ? '-200' : '-subtle'} fw-normal`
  }
  const validFunction = typeof onClick === 'function'
  if (validFunction) colorClass += ' clickable pointer'

  return (
    <span
      onClick={onClick}
      role='status'
      aria-label={ariaLabel}
      className={`badge ${className} ${colorClass}${size === 'md' ? ' fs-7' : ''}`}
      {...other}
    >
      {children}
    </span>
  )
}

Badge.propTypes = {
  variant: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
  chip: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node
}

export default Badge
